// @flow

import React, { type Node } from 'react';
import { Portal } from '@tectonics/commons/portal';
import { SubmitErrorDisplay } from './submit-error-display';
import { RetryMessageDisplay } from './retry-message-display';

export function MessagesDisplay(): Node {
  return (
    <Portal id="bromelia-messages-display">
      <RetryMessageDisplay />
      <SubmitErrorDisplay />
    </Portal>
  );
}
